var _circle, _path, _circle2, _ellipse, _ellipse2, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    transform: "rotate(90 26 26)",
    fill: "#ACE5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1797 39.0867L10.7326 28.8364H40.6389L39.8551 39.0867H12.1797Z",
    fill: "#333B4F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.6757,
    cy: 25.6756,
    r: 15.2757,
    fill: "#FFF3F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.4618,
    cy: 28.8361,
    rx: 1.0535,
    ry: 1.58025,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.8897,
    cy: 28.8361,
    rx: 1.0535,
    ry: 1.58025,
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7828 32.5239H23.3054C23.3054 33.5774 24.0955 34.3675 25.6758 34.3675C27.1657 34.3675 27.695 33.2263 27.7828 32.5239Z",
    fill: "#F09387"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4078 25.2151C19.8819 17.9037 23.3162 18.9449 24.9213 19.4315C25.2871 19.5424 25.5579 19.6245 25.7836 19.5724C25.835 19.5605 25.893 19.5463 25.9576 19.5304C27.4914 19.1534 32.7205 17.8681 40.9438 26.1933C40.9495 26.0214 40.9524 25.8489 40.9524 25.6756C40.9524 17.2391 34.1132 10.3999 25.6767 10.3999C17.3942 10.3999 10.6512 16.9916 10.4078 25.2151Z",
    fill: "#333B4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7024 16.1151C13.3349 16.7674 12.3399 17.3532 11.2021 20.8757C16.9182 20.8757 28.543 21.1962 40.2351 20.933C39.8813 18.9963 38.1879 16.8844 37.699 16.1816C25.7471 15.9183 19.1587 15.8237 13.7024 16.1151Z",
    fill: "#0074FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile4);
export default __webpack_public_path__ + "static/media/img_profile_4.625e24b4518227dc581597618dab08a9.svg";
export { ForwardRef as ReactComponent };